import { combineReducers } from "redux";
import cart from "./cart.js";
import products from "./products.js";
import merchant from "./merchant";

export default combineReducers({ cart, products, merchant });
